import { render, staticRenderFns } from "./UserActionRightSide.vue?vue&type=template&id=0c8e4756&"
import script from "./UserActionRightSide.vue?vue&type=script&lang=js&"
export * from "./UserActionRightSide.vue?vue&type=script&lang=js&"
import style0 from "./UserActionRightSide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports